import type {ImageField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import type {IconType} from 'src/common/Icon'
import {BlockContainer} from './components/BlockContainer'
import {FactCard} from './components/FactCard'

export type StatCard = {
  icon: IconType
  value: string
  detail: string
}

export type ValueHeroProps = {
  heading: string
  image: ImageField
  annotation: string
  limitsNote: string
  statCards: StatCard[]
}

export const ValueHero = ({heading, image, annotation, limitsNote, statCards}: ValueHeroProps) => (
  <section
    data-slice-type="discovery_block"
    data-slice-variation="valueHero"
    data-nav-dark="true"
    className="grid grid-cols-main bg-green-base bg-discovery-glow bg-fixed px-5 py-12 md:px-10 md:py-16"
  >
    <div className="col-[inner] w-full max-w-[46.25rem] justify-self-center">
      <BlockContainer headline={heading} subhead={annotation}>
        <div className="flex flex-col gap-5">
          {isFilled.image(image) && (
            <div className="relative aspect-video overflow-hidden rounded-card border border-moss-white/10 bg-moss-black/20">
              <PrismicNextImage field={image} fill className="object-contain" />
            </div>
          )}
          {statCards.length > 0 && (
            <div className="flex flex-wrap gap-3">
              {statCards.map((statCard, statCardIndex) => (
                <FactCard
                  key={statCardIndex}
                  icon={statCard.icon}
                  value={statCard.value}
                  detail={statCard.detail}
                  row
                />
              ))}
            </div>
          )}
          {limitsNote && (
            <div className="flex items-center gap-3 border-t border-moss-white/[8%] pt-5 text-13 text-green-mist-dim">
              <span>{limitsNote}</span>
            </div>
          )}
        </div>
      </BlockContainer>
    </div>
  </section>
)
